import type { ICrossTabEvent } from 'bz-utilities/modules/plugins/register/stores/mediator';

export class CacheUpdateEvent implements ICrossTabEvent {
  public readonly __crossTabEvent = true as const;

  public constructor(init?: Partial<CacheUpdateEvent>) {
    (Object as any).assign(this, init);
  }
}
